import type { AnalyticsProperties } from './types';
import { getAnalyticsCustomerType } from './registrationMeta';
import { pathToScreenName } from './screenName';
import { getAccountId } from '../utils/storage';
import { ENVIRONMENT, getLanguage } from './utils/runtimeMeta';

/**
 * Attaches reserved metadata. Caller properties cannot override these fields.
 * Timestamps are left to GA4 — we do not invent a client-side `timestamp`.
 *
 * Global GA4 params: application_id, language, customer_type, screen_name.
 * entry_point is intentionally omitted until openers pass a source signal.
 * Location is sent as `page_location` on screen_view (not as route / page_path).
 */
export function enrichProperties(
    properties: AnalyticsProperties,
    currentPath: string | null
): AnalyticsProperties {
    return {
        ...properties,
        environment: ENVIRONMENT,
        language: getLanguage() ?? null,
        application_id: getAccountId(),
        customer_type: getAnalyticsCustomerType(),
        screen_name: pathToScreenName(currentPath),
    };
}
